import {
  SquaayRiderAndroidLink,
  SquaayRiderIOSLink,
} from "../../common/constant";
import "./DownloadOptions.css";

const stores = [
  {
    name: "App Store",
    description:
      "Download the rider app for easy job pickup and real-time delivery updates.",
    url: SquaayRiderIOSLink,
    icon: "",
  },
  {
    name: "Google Play",
    description:
      "Install Squaay Riders for Android and start earning on every delivery.",
    url: SquaayRiderAndroidLink,
    icon: "▶",
  },
];

export default function RiderDownloadOptions() {
  return (
    <section className="download-options">
      <div className="download-options__header">
        <p className="download-options__eyebrow">Riders App</p>
        <h2 className="download-options__title">Download Squaay Riders</h2>
        <p className="download-options__subtitle">
          Get the rider app that helps you find nearby deliveries, manage
          earnings, and stay connected to the Squaay team.
        </p>
      </div>

      <div className="download-options__cards">
        {stores.map((store) => (
          <article key={store.name} className="download-card">
            <div className="download-card__top">
              <div className="download-card__icon">{store.icon}</div>
              <div className="download-card__content">
                <h3>{store.name}</h3>
                <p className="download-card__text">{store.description}</p>
              </div>
            </div>
            <div className="download-card__action">
              <a
                className="download-card__button"
                href={store.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {`Download on ${store.name}`}
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
